/**
 * Takes an ISO Date string and makes it user readable.
 *
 * @param {file} str file
 * @returns {boolean}
 */
export default function CsvEncodingChecker(file) {
  // const file = e.target.files[0];
  if (!file) return;

  const reader = new FileReader(file);

  // Read file as raw binary buffer
  reader.onload = (event) => {
    const buffer = event.target.result;
    const uint8Array = new Uint8Array(buffer);

    let isUtf8 = false;
    // let hasBom = false;

    try {
      // fatal:true makes decoder throw if invalid UTF-8
      const decoder = new TextDecoder('utf-8', { fatal: true });
      decoder.decode(uint8Array);
      isUtf8 = true;
    } catch (err) {
      isUtf8 = false;
    }

    // Check first 3 bites for BOM signature ( for excel csv file validation)
    // if (
    //   uint8Array.length >= 3
    //   && uint8Array[0] === 0xef
    //   && uint8Array[1] === 0xbb
    //   && uint8Array[2] === 0xbf
    // ) {
    //   hasBom = true;
    // }

    return isUtf8;
  };
}
